import moment from 'moment';

export const TimeZoneAbbreviated = (date: string): string => {
  const dateString: string = new Date(date).toString();
  const match: RegExpMatchArray | null = dateString.match(/\((.+)\)/);

  // Check if a match was found
  if (!match || match.length < 2) {
    return ''; // Return an empty string or handle the case as needed
  }

  const tz: string = match[1];

  // In Chrome browser, new Date().toString() is
  // "Thu Aug 06 2020 16:21:38 GMT+0530 (India Standard Time)"

  // In Safari browser, new Date().toString() is
  // "Thu Aug 06 2020 16:24:03 GMT+0530 (IST)"

  if (tz.includes(' ')) {
    return tz
      .split(' ')
      .map((part: string) => part[0])
      .join('');
  } else {
    return tz;
  }
};

export function GetUserTimeZone(): string {
  // Get the user's timezone
  const userTimezone = Intl?.DateTimeFormat().resolvedOptions().timeZone;

  return userTimezone || '';
}

export function ConvertUTCDatesBasedOnTimeZone(
  datesRequested: string[],
  timeZone?: string,
): string[] {
  const formatedDateRequested = datesRequested?.map((date: string) => {
    const dateTime = moment(date);

    return timeZone
      ? dateTime.tz(timeZone).format('YYYY-MM-DD')
      : dateTime.format('YYYY-MM-DD');
  });

  return formatedDateRequested;
}

export const getStartDateAndTime = (date: string | moment.Moment, practiceTimeZone: string): string => {
    let momentDate: moment.Moment;

    // Ensure date is a valid Moment object
    if (moment.isMoment(date)) {
      // Use clone to avoid mutation
        momentDate = date.clone();
    } else {
      // Parse string as UTC
        momentDate = moment.utc(date); 
    }

    if (!momentDate.isValid()) {
        throw new Error("Invalid date provided.");
    }

    // Convert UTC date-time to the specified time zone
    const localizedDate = momentDate.tz(practiceTimeZone);

    // Move to the start of the day (00:00:00.000) in the target time zone
    localizedDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

    // Format output to include the correct UTC offset dynamically
    const formattedDateTime = localizedDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ");

    return formattedDateTime;
};



export function isValidDateTime(dateTime: string): Date {
  const date = new Date(dateTime);

  if (isNaN(date.getTime())) {
    throw new Error('Invalid dateTime format');
  }

  return date;
}

export function convertStartDateTimeToString(getStartDateTime: string): string {
  const startDate = isValidDateTime(getStartDateTime);

  return startDate.toString();
}

export function getEndTime(
  getStartDateTime: string,
  getDuration: number,
): Date {
  const startDate = isValidDateTime(getStartDateTime);

  if (typeof getDuration !== 'number' || getDuration < 0) {
    throw new Error('Invalid duration');
  }

  const endTime = new Date(startDate.getTime() + getDuration * 60000);

  return endTime;
}

export function ConvertToLocalDate(date: string | Date): string {
  if (date) {
    return new Date(date).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } else {
    return '';
  }
}

export function ConvertToLocalTime(date: string | Date): string {
  if (date) {
    return new Date(date).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });
  } else {
    return '';
  }
}

export const getTimeToShowForAvailabilityWidget = (
  slotStartDateTime: string,
) => {
  try {
    const dateTime = moment(slotStartDateTime);

    if (!dateTime.isValid()) {
      throw new Error('Invalid date format');
    }

    const formattedTime = dateTime.format('h:mm A');

    return formattedTime;
  } catch (error: any) {
    console.error(error && error?.message);

    return 'Invalid time'; // Default return for error case
  }
};

// / If inputValue is just a year (e.g., "2013"), set it to Jan 1st of that year
export const convertYearToUTC = (year: string) => {
  return new Date(Date.UTC(parseInt(year), 0, 1, 12, 0, 0));
};

export const convertDateToUTC = (dateString : string) => {
  const localDate = new Date(dateString);

  return new Date(Date.UTC(
      localDate.getFullYear(),
      localDate.getMonth(),
      localDate.getDate(),
      12, 0, 0
  ));
};